import React from "react";

const Social = () => {
  const socialLinks = [
    {
      icon: "fa-linkedin",
      url: "https://in.linkedin.com/in/ajeshbs",
      title: "LinkedIn",
    },
    {
      icon: "fa-instagram",
      url: "https://instagram.com/ajeshbs.me",
      title: "Instagram",
    },
    {
      icon: "fa-github",
      url: "https://github.com/ajeshbs",
      title: "GitHub",
    },
    {
      icon: "fa-shield",
      url: "https://www.credly.com/users/ajeshbs",
      title: "Credly",
    },
  ];

  return (
    <div className="social-icons">
      {socialLinks.map((link, i) => (
        <a
          key={i}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          title={link.title}
        >
          <i className={`fa ${link.icon}`}></i>
        </a>
      ))}
    </div>
  );
};

export default Social;
